<template>
  <div class="comtainer-main">
    <Head show="" :goBack="true" title="所有订单"></Head>
    <div class="content">
        <div class="van-card">
            <div class="title cl">
                <div class="number">订单编号：780000012333</div>
                <div class="time">2020-11-26 11:15</div>
            </div>
            <div class="van-card__header">
                <a class="van-card__thumb">
                    <div class="van-image" style="width: 100%; height: 100%;"><img src="https://img.yzcdn.cn/vant/ipad.jpeg" class="van-image__img" style="object-fit: cover;"></div>
                </a>
                <div class="van-card__content">
                    <div>
                        <div class="van-card__title van-multi-ellipsis--l2">五粮液</div>
                        <div class="van-card__desc van-ellipsis">商品类型：水酒</div>
                    </div>
                    <div class="van-card__bottom">
                        <div class="van-card__price">
                            <div><span class="van-card__price-currency">付款方式：微信支付</span></div>
                        </div>
                        <div class="van-card__num">¥ 10.00</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Toast } from 'vant';
export default {
  name: 'orderForm',
  components: {
  },
  mounted () {
  },
  created() {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style  scoped>
.comtainer-main{
    background-color: #f7f8fa;
}
.content{
    padding-top: 100px;
    overflow: hidden;
}
.van-card{
    margin: 20px 25px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 12px #ebedf0;
}
.van-card__title{
    padding-top: 30px;
    color: #333;
    font-weight:bold;
}

.van-card__desc{
    padding-top: 15px;
}
.van-card-type{
    padding-top: 8px;
    color: #7d7e80;
}
.van-card__bottom{
    padding-top: 15px;
}
.van-card__bottom .van-card__price{
    color: #7d7e80;
}
.van-card__bottom .van-card__num{
    font-weight:bold;
    color: #f1172d;
    font-size: 34px;
    position: relative;
    top: -4px;
}
.title{
    line-height: 40px;
    height: 40px;
    color: #606060;
    font-size: 24px;
}
.number{
    float: left;
}
.time{
    float: right;
}
</style>